import { render, staticRenderFns } from "./TdRefundAdjustRequest.vue?vue&type=template&id=ab4a23e6&"
import script from "./TdRefundAdjustRequest.vue?vue&type=script&lang=ts&"
export * from "./TdRefundAdjustRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports